import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_AddEditData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import PageTitle from "../layouts/PageTitle";
import { toast } from "react-toastify";
import { fn } from "jquery";

// ─── Column Definitions ───────────────────────────────────────────────────────
// ── Basic Info ──
// ── Sub-tables flattened (one row each, like Branch in MultiFirmEntry) ──
const COLS = [
  // Basic Info
  { key: "F_FirmMaster",       label: "Firm *",           type: "select",  optKey: "FirmMaster",        w: 160, placeholder: "-- Select Firm --" },
  { key: "F_BranchMaster",     label: "Branch",           type: "select",  optKey: "BranchMaster",      w: 160, placeholder: "-- Select Branch --" },
  { key: "SerialNo",           label: "Serial No",        type: "number",  w: 90 },
  { key: "Name",               label: "Employee Name *",  type: "text",    w: 190 },
  { key: "FatherName",         label: "Father Name",      type: "text",    w: 160 },
  { key: "CardNo",             label: "Card No",          type: "text",    w: 110 },
  { key: "EmployeeType",       label: "Emp. Type",        type: "select",  optKey: "EmployeeType",      w: 130, placeholder: "-- Select Type --" },
  { key: "Sex",                label: "Sex",              type: "select",  optKey: "Sex",               w: 100, placeholder: "-- Select Sex --" },
  { key: "DateOfBirth",        label: "Date of Birth",    type: "date",    w: 140 },
  { key: "DateOfRetire",       label: "Date of Retire",   type: "date",    w: 140 },
  { key: "MobileNo",           label: "Mobile No",        type: "text",    w: 130 },
  { key: "PermanentAddress",   label: "Perm. Address",    type: "text",    w: 200 },
  { key: "PresentAddress",     label: "Pres. Address",    type: "text",    w: 200 },
  { key: "F_DepartmentMaster", label: "Department",       type: "select",  optKey: "DepartmentMaster",  w: 160, placeholder: "-- Select Dept --" },
  { key: "F_DesignationMaster",label: "Designation",      type: "select",  optKey: "DesignationMaster", w: 170, placeholder: "-- Select Designation --" },
  { key: "Remark",             label: "Remark",           type: "text",    w: 200 },
  // ── ESI ──
  { key: "ESIApplicable",         label: "[ESI] Applicable",    type: "boolean", w: 120 },
  { key: "ESINo",                 label: "[ESI] ESI No",        type: "text",    w: 120 },
  { key: "ESIJoiningDate",        label: "[ESI] Join Date",     type: "date",    w: 130 },
  { key: "ESIOldEmployee",        label: "[ESI] Old Emp.",      type: "boolean", w: 110 },
  { key: "TICs",                  label: "[ESI] TICs",          type: "boolean", w: 90 },
  { key: "PICs",                  label: "[ESI] PICs",          type: "boolean", w: 90 },
  { key: "Accident",              label: "[ESI] Accident",      type: "boolean", w: 100 },
  // ── PF ──
  { key: "PFApplicable",          label: "[PF] Applicable",     type: "boolean", w: 120 },
  { key: "PFNo",                  label: "[PF] PF No",          type: "text",    w: 110 },
  { key: "UAN",                   label: "[PF] UAN",            type: "text",    w: 130 },
  { key: "PFJoinDate",            label: "[PF] Join Date",      type: "date",    w: 130 },
  { key: "ExtraPF",               label: "[PF] Extra PF",       type: "number",  w: 100 },
  { key: "EmplrPFOverLimit",      label: "[PF] Empl. OvLim",    type: "boolean", w: 120 },
  { key: "EmpleeDedOverLimit",    label: "[PF] Emplee Ded OvL", type: "boolean", w: 130 },
  { key: "PensionApplicable",     label: "[PF] Pension",        type: "boolean", w: 110 },
  { key: "PensionOverLimit",      label: "[PF] Pension OvLim",  type: "boolean", w: 120 },
  { key: "HigherPension",         label: "[PF] Higher Pension", type: "boolean", w: 120 },
  { key: "PFCalculationType",     label: "[PF] Calc. Type",     type: "select",  optKey: "PFCalcType",    w: 120, placeholder: "-- Select --" },
  { key: "FixedPFSalary",         label: "[PF] Fixed Salary",   type: "number",  w: 120 },
  { key: "OldMemberPF",           label: "[PF] Old Mbr PF",     type: "boolean", w: 110 },
  { key: "OldMemberPension",      label: "[PF] Old Mbr Pen.",   type: "boolean", w: 120 },
  { key: "PrevPFNo",              label: "[PF] Prev PF No",     type: "text",    w: 120 },
  { key: "OldUAN",                label: "[PF] Old UAN",        type: "text",    w: 120 },
  { key: "DateOfExitPr",          label: "[PF] Exit Date Pr.",  type: "date",    w: 130 },
  { key: "PMRPY",                 label: "[PF] PMRPY",          type: "boolean", w: 90 },
  { key: "PMGKY",                 label: "[PF] PMGKY",          type: "boolean", w: 90 },
  { key: "ABRY",                  label: "[PF] ABRY",           type: "boolean", w: 90 },
  // ── Other ──
  { key: "WeeklyHoliday",         label: "Weekly Holiday",      type: "select",  optKey: "WeeklyHoliday", w: 140, placeholder: "-- Select --" },
  // ── Bank ──
  { key: "BankName",              label: "[Bank] Name",         type: "text",    w: 180 },
  { key: "IFSCCode",              label: "[Bank] IFSC",         type: "text",    w: 120 },
  { key: "BankAccountNo",         label: "[Bank] A/c No",       type: "text",    w: 150 },
  { key: "NameAsBank",            label: "[Bank] Name as Bank", type: "text",    w: 160 },
  // ── Documents ──
  { key: "PanCardNo",             label: "[Doc] PAN No",        type: "text",    w: 140 },
  { key: "NameAsPerPan",          label: "[Doc] Name as PAN",   type: "text",    w: 180 },
  { key: "DrivingLicenceNo",      label: "[Doc] DL No",         type: "text",    w: 140 },
  { key: "DLExpiryDate",          label: "[Doc] DL Expiry",     type: "date",    w: 130 },
  { key: "NameAsPerDL",           label: "[Doc] Name as DL",    type: "text",    w: 160 },
  { key: "PassportNo",            label: "[Doc] Passport No",   type: "text",    w: 140 },
  { key: "PassportFrom",          label: "[Doc] Passport From", type: "date",    w: 130 },
  { key: "PassportTill",          label: "[Doc] Passport Till", type: "date",    w: 130 },
  { key: "PassportName",          label: "[Doc] Passport Name", type: "text",    w: 160 },
  { key: "IsInternationalEmployee", label: "[Doc] International", type: "boolean", w: 130 },
  { key: "CountryOrigin",         label: "[Doc] Country",       type: "text",    w: 130 },
  { key: "Nationality",           label: "[Doc] Nationality",   type: "text",    w: 130 },
  // ── Dept History (one row) ──
  { key: "Dept_F_DepartmentMaster",  label: "[DH] Department",    type: "select", optKey: "DepartmentMaster",  w: 160, placeholder: "-- Select Dept --" },
  { key: "Dept_F_DesignationMaster", label: "[DH] Designation",   type: "select", optKey: "DesignationMaster", w: 170, placeholder: "-- Select Designation --" },
  { key: "Dept_EffectiveDate",       label: "[DH] Effective Date", type: "date",  w: 140 },
  // ── Shift History (one row) ──
  { key: "F_ShiftMaster",            label: "[SH] Shift",         type: "select", optKey: "ShiftMaster",       w: 140, placeholder: "-- Select Shift --" },
  { key: "ShiftEffectiveFrom",       label: "[SH] Effective From", type: "date",   w: 140 },
  // ── Join History (one row) ──
  { key: "Join_JoinDate",         label: "[JH] Join Date",     type: "date",   w: 130 },
  { key: "Join_F_JoinTypeMaster", label: "[JH] Join Type",     type: "select", optKey: "JoinTypeMaster", w: 150, placeholder: "-- Select Type --" },
  { key: "Join_LeftDate",         label: "[JH] Left Date",     type: "date",   w: 130 },
  { key: "Join_ReasonOfLeft",     label: "[JH] Reason of Left",type: "text",   w: 170 },
  // ── Salary (one row) ──
  { key: "Sal_BasicSalary",       label: "[Sal] Basic Salary",   type: "number", w: 130 },
  { key: "Sal_GradePay",          label: "[Sal] Grade Pay",      type: "number", w: 120 },
  { key: "Sal_EffectiveDate",     label: "[Sal] Effective Date", type: "date",   w: 140 },
  { key: "Sal_F_BasicTypeMaster", label: "[Sal] Basic Type",     type: "select", optKey: "BasicTypeMaster", w: 150, placeholder: "-- Select Type --" },
  // ── Relative (one row) ──
  { key: "Rel_RelativeName",        label: "[Rel] Relative Name",     type: "text",   w: 160 },
  { key: "Rel_DateOfBirth",        label: "[Rel] Date of Birth",    type: "date",   w: 140 },
  { key: "Rel_Address",           label: "[Rel] Address",          type: "text",   w: 200 },
  { key: "Rel_F_RelationshipMaster", label: "[Rel] Relationship",    type: "select", optKey: "RelationshipMaster", w: 150, placeholder: "-- Select Relation --" },
  { key: "Rel_LivingWith",         label: "[Rel] Living With",      type: "select", optKey: "YesNo", w: 120, placeholder: "-- Select --" },
  { key: "Rel_ForESI",             label: "[Rel] For ESI",          type: "select", optKey: "YesNo", w: 100, placeholder: "-- Select --" },
  { key: "Rel_AadharNo",           label: "[Rel] Aadhar No",        type: "text",   w: 130 },
  // ── Nominee (one row) ──
  { key: "Nom_NomineeName",        label: "[Nom] Nominee Name",     type: "text",   w: 160 },
  { key: "Nom_Address",           label: "[Nom] Address",          type: "text",   w: 200 },
  { key: "Nom_F_RelationshipMaster", label: "[Nom] Relationship",    type: "select", optKey: "RelationshipMaster", w: 150, placeholder: "-- Select Relation --" },
  { key: "Nom_BirthDate",          label: "[Nom] Birth Date",       type: "date",   w: 130 },
  { key: "Nom_Amount",             label: "[Nom] Amount",           type: "number", w: 120 },
  { key: "Nom_ParentName",         label: "[Nom] Parent Name",      type: "text",   w: 160 },
  { key: "Nom_AadharNo",           label: "[Nom] Aadhar No",        type: "text",   w: 130 },
  // ── Allowances (modal table) ──
  { key: "Allowances",            label: "Allowances",         type: "modal",  w: 160 },
  // ── Deductions (modal table) ──
  { key: "Deductions",            label: "Deductions",         type: "modal",  w: 160 },
];

const emptyRow = () => {
  const row = Object.fromEntries(COLS.map((c) => [c.key, c.type === "boolean" ? "false" : c.type === "modal" ? [] : ""]));
  return { Id: 0, ...row };
};

// Map an API employee object → grid row format
const apiRowToGridRow = (r) => ({
  Id: r.Id ?? 0,
  ...Object.fromEntries(COLS.map((col) => {
    if (col.type === "modal") return [col.key, []]; // handled below
    let val = r[col.key];
    if (col.type === "boolean") val = val === true || val === "true" ? "true" : "false";
    else if (col.type === "date" && val) val = String(val).substring(0, 10); // strip time part
    else val = val === null || val === undefined ? "" : String(val);
    return [col.key, val];
  })),
  // Handle allowances JSON — API returns AllowanceJson
  Allowances: (() => {
    try {
      const raw = r.AllowanceJson || r.AllowancesJson;
      const allowances = raw ? JSON.parse(raw) : [];
      return Array.isArray(allowances) ? allowances : [];
    } catch (_) {
      return [];
    }
  })(),
  // Handle deductions JSON — API returns DeductionJson
  Deductions: (() => {
    try {
      const raw = r.DeductionJson || r.DeductionsJson;
      const deductions = raw ? JSON.parse(raw) : [];
      return Array.isArray(deductions) ? deductions : [];
    } catch (_) {
      return [];
    }
  })(),
  // Store original data for change tracking
  _originalData: r
});

// ─── Pure helpers ─────────────────────────────────────────────────────────────
const getSelRange = (foc, anc) => ({
  r1: Math.min(foc.r, anc.r), r2: Math.max(foc.r, anc.r),
  c1: Math.min(foc.c, anc.c), c2: Math.max(foc.c, anc.c),
});
const colLetter = (c) => {
  let s = ""; let n = c + 1;
  while (n > 0) { s = String.fromCharCode(64 + ((n - 1) % 26 + 1)) + s; n = Math.floor((n - 1) / 26); }
  return s;
};

// ─── Static styles ────────────────────────────────────────────────────────────
const KBD = { background: "#f3f4f6", border: "1px solid #d1d5db", borderRadius: "3px", padding: "1px 5px", fontSize: "10px", fontFamily: "monospace", color: "#374151" };
const TH_NUM = { width: "40px", minWidth: "40px", background: "#cbd5e1", border: "1px solid #adb5bd", textAlign: "center", fontSize: "11px", color: "#64748b", height: "28px", position: "sticky", top: 0, zIndex: 10, boxSizing: "border-box" };
const thCol = (w, inColSel) => ({ minWidth: `${w}px`, width: `${w}px`, background: inColSel ? "#1b5e20" : "#217346", color: "#fff", border: "1px solid #1b5e20", padding: "0 6px", fontSize: "12px", fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", height: "28px", position: "sticky", top: 0, zIndex: 5, boxSizing: "border-box", userSelect: "none" });
const rnTd = (ri, focR) => ({ width: "40px", minWidth: "40px", background: focR === ri ? "#dbeafe" : "#f1f5f9", border: "1px solid #d0d0d0", textAlign: "center", fontSize: "11px", color: "#64748b", height: "28px", fontWeight: focR === ri ? 700 : 400, padding: 0, position: "sticky", left: 0, zIndex: 2, userSelect: "none" });
const tdStyle = (isFoc, isSel, ri, isEditFoc = false) => ({ height: "28px", padding: isEditFoc ? 0 : "0 3px", border: isFoc ? "2px solid #1565c0" : isSel ? "1px solid #90caf9" : "1px solid #d0d0d0", background: isFoc ? "#ffffff" : isSel ? "#bbdefb" : ri % 2 === 0 ? "#ffffff" : "#f8f9fa", cursor: "cell", position: "relative", zIndex: isFoc ? 4 : isSel ? 2 : 1, boxSizing: "border-box", overflow: "hidden", verticalAlign: "middle" });

// Column group header bands (purely visual)
const COL_GROUPS = [
  { label: "Basic Info",    startKey: "F_FirmMaster",            endKey: "Remark",                color: "#1565c0" },
  { label: "ESI",          startKey: "ESIApplicable",           endKey: "Accident",              color: "#00838f" },
  { label: "PF",           startKey: "PFApplicable",            endKey: "ABRY",                  color: "#1565c0" },
  { label: "Other",        startKey: "WeeklyHoliday",           endKey: "WeeklyHoliday",         color: "#4527a0" },
  { label: "Bank",         startKey: "BankName",                endKey: "NameAsBank",            color: "#2e7d32" },
  { label: "Documents",    startKey: "PanCardNo",               endKey: "Nationality",           color: "#4e342e" },
  { label: "Dept. History",startKey: "Dept_F_DepartmentMaster", endKey: "Dept_EffectiveDate",    color: "#6a1b9a" },
  { label: "Shift History",startKey: "F_ShiftMaster",           endKey: "ShiftEffectiveFrom",    color: "#9c27b0" },
  { label: "Join History", startKey: "Join_JoinDate",           endKey: "Join_ReasonOfLeft",     color: "#bf360c" },
  { label: "Salary",       startKey: "Sal_BasicSalary",         endKey: "Sal_F_BasicTypeMaster", color: "#1b5e20" },
  { label: "Relative",     startKey: "Rel_RelativeName",        endKey: "Rel_AadharNo",          color: "#795548" },
  { label: "Nominee",      startKey: "Nom_NomineeName",         endKey: "Nom_AadharNo",          color: "#607d8b" },
  { label: "Allowances",   startKey: "Allowances",              endKey: "Allowances",            color: "#e65100" },
  { label: "Deductions",   startKey: "Deductions",              endKey: "Deductions",            color: "#ad1457" },
];

// ─── Main Component ───────────────────────────────────────────────────────────
const MultiEmployeeEntry = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rows,      setRows]      = useState(() => Array.from({ length: 10 }, emptyRow));
  const [focus,     setFocus]     = useState({ r: 0, c: 0 });
  const [anchor,    setAnchor]    = useState({ r: 0, c: 0 });
  const [editMode,      setEditMode]      = useState(false);
  const [visibleKeys,   setVisibleKeys]   = useState(() => new Set(COLS.map(c => c.key)));
  const [colPickerOpen, setColPickerOpen] = useState(false);
  const [allowancesModal, setAllowancesModal] = useState({ open: false, rowIndex: -1 });
  const [tempAllowances, setTempAllowances] = useState([]);
  const [originalTempAllowances, setOriginalTempAllowances] = useState([]);
  const [modalAllowanceViewIndex, setModalAllowanceViewIndex] = useState({});
  const [modalExpandedAllowances, setModalExpandedAllowances] = useState({});
  // Deduction modal state
  const [deductionsModal, setDeductionsModal] = useState({ open: false, rowIndex: -1 });
  const [tempDeductions, setTempDeductions] = useState([]);
  const [originalTempDeductions, setOriginalTempDeductions] = useState([]);
  const [modalDeductionViewIndex, setModalDeductionViewIndex] = useState({});
  const [modalExpandedDeductions, setModalExpandedDeductions] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    FirmMaster:        [],
    BranchMaster:      [], // Global branches (not used now)
    DepartmentMaster:  [],
    DesignationMaster: [],
    ShiftMaster:       [],
    JoinTypeMaster:    [],
    BasicTypeMaster:   [],
    AllowanceMaster:   [],
    DeductionMaster:   [],
    RelationshipMaster:[],
    PFCalcType: [
      { Id: "Percentage", Name: "Percentage" },
      { Id: "Manual",     Name: "Manual"     },
    ],
    WeeklyHoliday: [
      { Id: "Sunday",    Name: "Sunday" },
      { Id: "Monday",    Name: "Monday" },
      { Id: "Tuesday",   Name: "Tuesday" },
      { Id: "Wednesday", Name: "Wednesday" },
      { Id: "Thursday",  Name: "Thursday" },
      { Id: "Friday",    Name: "Friday" },
      { Id: "Saturday",  Name: "Saturday" },
    ],
    YesNo: [
      { Id: "0", Name: "No" },
      { Id: "1", Name: "Yes" },
    ],
    EmployeeType: [
      { Id: "Permanent", Name: "Permanent" },
      { Id: "Temporary", Name: "Temporary" },
      { Id: "Contract",  Name: "Contract"  },
      { Id: "Daily Wage",Name: "Daily Wage"},
    ],
    Sex: [
      { Id: "Male",   Name: "Male"   },
      { Id: "Female", Name: "Female" },
      { Id: "Other",  Name: "Other"  },
    ],
  });
  
  // Row-wise branch data: array of arrays where index matches row index
  const [rowBranches, setRowBranches] = useState([]);
  const [pageSize,    setPageSize]    = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const rowsRef         = useRef(rows);
  const focusRef        = useRef(focus);
  const anchorRef       = useRef(anchor);
  const editModeRef     = useRef(false);
  const editModeTypeRef = useRef("typing");
  const editOrigRef     = useRef("");
  const inputRef        = useRef(null);
  const gridRef         = useRef(null);
  const focusedCellRef  = useRef(null);
  const openDropdownRef = useRef(false);
  const colPickerRef    = useRef(null);
  const visColsRef      = useRef(COLS);
  const currentPageRef  = useRef(currentPage);

  useEffect(() => { rowsRef.current     = rows;     }, [rows]);
  useEffect(() => { focusRef.current    = focus;    }, [focus]);
  useEffect(() => { anchorRef.current   = anchor;   }, [anchor]);
  useEffect(() => { editModeRef.current = editMode; }, [editMode]);
  useEffect(() => { currentPageRef.current = currentPage; }, [currentPage]);

  // Visible columns derived from visibleKeys (updated every render)
  const visCOLS = COLS.filter(c => visibleKeys.has(c.key));
  visColsRef.current = visCOLS;

  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(rows.length, currentPage * pageSize);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  useEffect(() => {
    const focusRow = focus.r;
    const pageNum = Math.floor(focusRow / pageSize) + 1;
    if (pageNum !== currentPageRef.current && pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  }, [focus.r, pageSize, totalPages]);

  // Clamp focus/anchor when columns are hidden
  useEffect(() => {
    const maxC = visColsRef.current.length - 1;
    if (maxC < 0) return;
    setFocus(f => ({ ...f, c: Math.min(f.c, maxC) }));
    setAnchor(a => ({ ...a, c: Math.min(a.c, maxC) }));
    setEditMode(false);
  }, [visibleKeys]); // eslint-disable-line react-hooks/exhaustive-deps

  // Close column picker on outside click
  useEffect(() => {
    if (!colPickerOpen) return;
    const handleOutside = (e) => {
      if (colPickerRef.current && !colPickerRef.current.contains(e.target)) setColPickerOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [colPickerOpen]);

  useEffect(() => {
    const fetchAll = async () => {
      // Load all dropdowns
      await Promise.all([
        Fn_FillListData(dispatch, setDropdowns, "FirmMaster",         `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "DepartmentMaster",   `${API_WEB_URLS.MASTER}/0/token/DepartmentMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "DesignationMaster",  `${API_WEB_URLS.MASTER}/0/token/DesignationMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "ShiftMaster",        `${API_WEB_URLS.MASTER}/0/token/ShiftMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "JoinTypeMaster",     `${API_WEB_URLS.MASTER}/0/token/JoinTypeMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "BasicTypeMaster",    `${API_WEB_URLS.MASTER}/0/token/BasicTypeMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "RelationshipMaster", `${API_WEB_URLS.MASTER}/0/token/RelationshipMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "AllowanceMaster",    `${API_WEB_URLS.MASTER}/0/token/AllowanceMaster/Id/0`),
        Fn_FillListData(dispatch, setDropdowns, "DeductionMaster",    `${API_WEB_URLS.MASTER}/0/token/DeductionMaster/Id/0`),
      ]);
      // Load existing employee data
      await FetchAllEmployee();
    };
    fetchAll();
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const FetchAllEmployee = async () => {
    try {
      const firmId = (() => { try { return JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; } catch { return 0; } })();
      const res = await Fn_FillListData(dispatch, () => {}, "none",
        `${API_WEB_URLS.MASTER}/0/token/EmployeeDataAll/Id/${firmId}`);
      if (res && res.length > 0) {
        const loaded = res.map(apiRowToGridRow);
        // Pad with empty rows so there are at least 5 blank rows after existing data
        const blanks = Array.from({ length: 5 }, emptyRow);
        setRows([...loaded, ...blanks]);
        console.log(`Loaded ${loaded.length} existing employees`);
      } else {
        // If no data, keep the default empty rows
        console.log("No existing employee data found");
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    const container = gridRef.current; const cell = focusedCellRef.current;
    if (!container || !cell) return;
    const cRect = container.getBoundingClientRect(); const eRect = cell.getBoundingClientRect();
    const stickyLeft = 40;
    if (eRect.left < cRect.left + stickyLeft) container.scrollLeft -= cRect.left + stickyLeft - eRect.left;
    else if (eRect.right > cRect.right) container.scrollLeft += eRect.right - cRect.right;
    const stickyTop = 56; // 2 header rows (group + col names)
    if (eRect.top < cRect.top + stickyTop) container.scrollTop -= cRect.top + stickyTop - eRect.top;
    else if (eRect.bottom > cRect.bottom) container.scrollTop += eRect.bottom - cRect.bottom;
  }, [focus]);

  useEffect(() => {
    if (editMode) {
      const el = inputRef.current; if (!el) return;
      el.focus();
      const supportsSelection = el.setSelectionRange && el.tagName !== "SELECT" && el.type !== "time" && el.type !== "number";
      if (supportsSelection) { try { el.setSelectionRange(el.value?.length ?? 0, el.value?.length ?? 0); } catch (_) {} }
      if (openDropdownRef.current && el.tagName === "SELECT") {
        openDropdownRef.current = false;
        try { el.showPicker(); } catch (_) {}
      }
    } else { gridRef.current?.focus(); }
  }, [focus, editMode]);

  const selRange = getSelRange(focus, anchor);
  const inSel    = (r, c) => r >= selRange.r1 && r <= selRange.r2 && c >= selRange.c1 && c <= selRange.c2;
  const isFoc    = (r, c) => focus.r === r && focus.c === c;

  const ensureRows = useCallback((needed) => {
    setRows((prev) => prev.length >= needed ? prev : [...prev, ...Array.from({ length: needed - prev.length }, emptyRow)]);
    // Also ensure rowBranches array has same length
    setRowBranches((prev) => {
      if (prev.length >= needed) return prev;
      const newBranches = [...prev];
      while (newBranches.length < needed) {
        newBranches.push([]); // Empty branch array for new rows
      }
      return newBranches;
    });
  }, []);

  // Function to load branches for a specific firm in a specific row
  const loadBranchesForRow = useCallback(async (rowIndex, firmId) => {
    if (!firmId) {
      // Clear branches for this row if no firm selected
      setRowBranches(prev => {
        const newBranches = [...prev];
        // Ensure array is long enough
        while (newBranches.length <= rowIndex) {
          newBranches.push([]);
        }
        newBranches[rowIndex] = [];
        return newBranches;
      });
      return;
    }

    try {
      // Use fetchBranchArray to get branches for selected firm
      const branchArray = await fetchBranchArray(firmId);
      
      // Update rowBranches array at specific row index
      setRowBranches(prev => {
        const newBranches = [...prev];
        // Ensure array is long enough
        while (newBranches.length <= rowIndex) {
          newBranches.push([]);
        }
        // Replace/Push branches at this row index
        newBranches[rowIndex] = branchArray || [];
        console.log(`Row ${rowIndex}: Updated branches for FirmId ${firmId}:`, newBranches[rowIndex]);
        return newBranches;
      });
    } catch (error) {
      console.error(`Error loading branches for row ${rowIndex}, firm ${firmId}:`, error);
      // Set empty array on error
      setRowBranches(prev => {
        const newBranches = [...prev];
        while (newBranches.length <= rowIndex) {
          newBranches.push([]);
        }
        newBranches[rowIndex] = [];
        return newBranches;
      });
    }
  }, []);
  const fetchBranchArray = async(firmId) => {
    const BranchArray = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/BranchMaster/Id/`+firmId);
    console.log("Fetched Branches for FirmId", firmId, BranchArray);
    return BranchArray || []; // Return empty array if undefined
  }
  const gotoCell = useCallback((r, c, extendSel = false) => {
    const nr = Math.max(0, r); const nc = Math.max(0, Math.min(c, visColsRef.current.length - 1));
    if (nr >= rowsRef.current.length) ensureRows(nr + 1);
    if (!extendSel) setAnchor({ r: nr, c: nc });
    setFocus({ r: nr, c: nc }); setEditMode(false);
  }, [ensureRows]);

  const handlePageChange = useCallback((newPage) => {
    const totalP = Math.max(1, Math.ceil(rowsRef.current.length / pageSize));
    if (newPage < 1 || newPage > totalP) return;
    setCurrentPage(newPage);
    const newRow = (newPage - 1) * pageSize;
    setFocus(f => ({ r: newRow, c: f.c }));
    setAnchor(a => ({ r: newRow, c: a.c }));
  }, [pageSize]);

  const handlePageSizeChange = useCallback((newSize) => {
    setPageSize(newSize);
    setCurrentPage(1);
    setFocus(f => ({ r: 0, c: f.c }));
    setAnchor(a => ({ r: 0, c: a.c }));
  }, []);

  const addNewRow = useCallback(() => {
    setRows(prev => {
      const next = [...prev, emptyRow()];
      const newIdx = next.length - 1;
      setTimeout(() => {
        setFocus({ r: newIdx, c: 0 });
        setAnchor({ r: newIdx, c: 0 });
        setEditMode(true);
      }, 0);
      return next;
    });
  }, []);

  const setCell = useCallback(async (r, key, val) => {
    setRows((prev) => prev.map((row, i) => (i === r ? { ...row, [key]: val } : row)));
    
    // If Firm is being changed, load branches for this row and clear existing branch selection
    if (key === "F_FirmMaster") {
      await loadBranchesForRow(r, val);
      // Also clear the branch selection for this row since firm changed
      if (val !== rowsRef.current[r]?.F_FirmMaster) {
        setRows((prev) => prev.map((row, i) => (i === r ? { ...row, F_BranchMaster: "" } : row)));
      }
    }
  }, [loadBranchesForRow]);

  const enterEditMode = useCallback((r, c, overwriteChar = null) => {
    const col = visColsRef.current[c];
    if (!col) return;
    editOrigRef.current     = rowsRef.current[r]?.[col.key] ?? "";
    editModeTypeRef.current = overwriteChar === null ? "f2" : "typing";
    if (overwriteChar !== null && (col.type === "text" || col.type === "number" || col.type === "time"))
      setCell(r, col.key, overwriteChar); // No await needed here, fire and forget
    setEditMode(true);
  }, [setCell]);

  const displayVal = (col, val) => {
    if (col.type === "select") { 
      let options = [];
      // For BranchMaster, we need to find which row this is for - but since this is displayVal, we can't easily determine row index
      // We'll handle this in the cell rendering instead
      if (col.optKey === "BranchMaster") {
        // This is a bit tricky since displayVal doesn't have row context
        // We'll just try to find the option in any of the branch arrays
        for (let branches of rowBranches) {
          const opt = branches.find((o) => String(o.Id) === String(val));
          if (opt) return opt.Name;
        }
        return "";
      } else {
        const opt = (dropdowns[col.optKey] || []).find((o) => String(o.Id) === String(val)); 
        return opt ? opt.Name : "";
      }
    }
    if (col.type === "boolean") return val === "true" ? "Yes" : "No";
    if (col.type === "modal" && col.key === "Allowances") {
      const allowances = val || [];
      const distinctCount = new Set(allowances.map(a => a.F_AllowanceMaster).filter(v => v)).size;
      if (distinctCount === 0) return "Click to add";
      return `${distinctCount} allowance(s)`;
    }
    if (col.type === "modal" && col.key === "Deductions") {
      const deductions = Array.isArray(val) ? val : [];
      const distinctCount = new Set(deductions.map(d => d.F_DeductionMaster).filter(v => v)).size;
      if (distinctCount === 0) return "Click to add";
      return `${distinctCount} deduction(s)`;
    }
    return val ?? "";
  };

  const doPaste = useCallback((text, startR, startC) => {
    if (!text) return;
    const pasted = text.replace(/\r/g, "").trimEnd().split("\n").map((l) => l.split("\t"));
    setRows((prev) => {
      const next = [...prev];
      while (next.length < startR + pasted.length) next.push(emptyRow());
      pasted.forEach((cols, dr) => cols.forEach((val, dc) => { const tc = startC + dc; if (tc < visColsRef.current.length) next[startR + dr] = { ...next[startR + dr], [visColsRef.current[tc].key]: val.trim() }; }));
      return next;
    });
  }, []);

  const doCopy = useCallback(() => {
    const { r1, r2, c1, c2 } = getSelRange(focusRef.current, anchorRef.current);
    const lines = [];
    for (let ri = r1; ri <= r2; ri++) { const cells = []; for (let ci = c1; ci <= c2; ci++) cells.push(String(rowsRef.current[ri]?.[visColsRef.current[ci].key] ?? "")); lines.push(cells.join("\t")); }
    navigator.clipboard?.writeText(lines.join("\n"));
  }, []);

  const clearSel = useCallback(() => {
    const { r1, r2, c1, c2 } = getSelRange(focusRef.current, anchorRef.current);
    setRows((prev) => { const next = prev.map((row) => ({ ...row })); for (let ri = r1; ri <= r2; ri++) for (let ci = c1; ci <= c2; ci++) { const col = visColsRef.current[ci]; if (col) next[ri][col.key] = col.type === "boolean" ? "false" : ""; } return next; });
  }, []);

  const selectAll = useCallback(() => { setAnchor({ r: 0, c: 0 }); setFocus({ r: rowsRef.current.length - 1, c: visColsRef.current.length - 1 }); }, []);

  const handleKey = useCallback((e) => {
    const { r, c } = focusRef.current;
    const col = visColsRef.current[c];
    if (!col) return;
    const isTextLike = col.type === "text" || col.type === "number" || col.type === "time" || col.type === "date";
    const shift = e.shiftKey; const ctrl = e.ctrlKey || e.metaKey; const inEdit = editModeRef.current;
    if (ctrl) {
      if (e.key.toLowerCase() === "c") { doCopy(); return; }
      if (e.key.toLowerCase() === "v") { e.preventDefault(); navigator.clipboard?.readText().then((t) => doPaste(t, r, c)); return; }
      if (e.key.toLowerCase() === "a") { e.preventDefault(); selectAll(); return; }
      return;
    }
    if (inEdit) {
      const isF2Mode = editModeTypeRef.current === "f2";
      switch (e.key) {
        case "Escape": e.preventDefault(); setCell(r, col.key, editOrigRef.current); setEditMode(false); break;
        case "Enter":  e.preventDefault(); e.stopPropagation(); gotoCell(r + 1, c); break;
        case "Tab":    e.preventDefault(); e.stopPropagation(); if (shift) { c === 0 ? gotoCell(r - 1, visColsRef.current.length - 1) : gotoCell(r, c - 1); } else { c === visColsRef.current.length - 1 ? gotoCell(r + 1, 0) : gotoCell(r, c + 1); } break;
        case "ArrowUp":    if (isF2Mode) break; e.preventDefault(); e.stopPropagation(); gotoCell(r - 1, c); break;
        case "ArrowDown":  if (isF2Mode) break; e.preventDefault(); e.stopPropagation(); gotoCell(r + 1, c); break;
        case "ArrowLeft":  if (isF2Mode) break; e.preventDefault(); e.stopPropagation(); gotoCell(r, c - 1); break;
        case "ArrowRight": if (isF2Mode) break; e.preventDefault(); e.stopPropagation(); gotoCell(r, c + 1); break;
        default: break;
      }
      return;
    }
    switch (e.key) {
      case "Tab":    e.preventDefault(); if (shift) { c === 0 ? gotoCell(r - 1, visColsRef.current.length - 1) : gotoCell(r, c - 1); } else { c === visColsRef.current.length - 1 ? gotoCell(r + 1, 0) : gotoCell(r, c + 1); } break;
      case "Enter":  e.preventDefault(); e.stopPropagation(); gotoCell(r + 1, c); break;
      case "F2":     e.preventDefault(); enterEditMode(r, c, null); break;
      case "ArrowUp":    e.preventDefault(); e.stopPropagation(); gotoCell(r - 1, c, shift); break;
      case "ArrowDown":  e.preventDefault(); e.stopPropagation(); gotoCell(r + 1, c, shift); break;
      case "ArrowLeft":  e.preventDefault(); e.stopPropagation(); gotoCell(r, c - 1, shift); break;
      case "ArrowRight": e.preventDefault(); e.stopPropagation(); gotoCell(r, c + 1, shift); break;
      case "Delete": case "Backspace": e.preventDefault(); clearSel(); break;
      case " ": if (col.type === "select" || col.type === "boolean") { e.preventDefault(); openDropdownRef.current = true; enterEditMode(r, c, null); } else if (col.type === "modal") { e.preventDefault(); if (col.key === "Allowances") openAllowancesModal(r); else if (col.key === "Deductions") openDeductionsModal(r); } break;
      default: if (isTextLike && e.key.length === 1) { e.preventDefault(); enterEditMode(r, c, e.key); } break;
    }
  }, [gotoCell, enterEditMode, setCell, doCopy, doPaste, clearSel, selectAll]);

  const handleGridKeyDown = useCallback((e) => {
    if (e.target !== gridRef.current) {
      const isF2Mode = editModeTypeRef.current === "f2";
      if (!isF2Mode && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) e.preventDefault();
      return;
    }
    handleKey(e);
  }, [handleKey]);

  const handleCellClick = useCallback((r, c, e) => {
    const col = visCOLS[c];
    if (col && col.type === "modal" && col.key === "Allowances") {
      openAllowancesModal(r);
      return;
    }
    if (col && col.type === "modal" && col.key === "Deductions") {
      openDeductionsModal(r);
      return;
    }
    if (e.shiftKey) { setEditMode(false); setFocus({ r, c }); } else { gotoCell(r, c); }
  }, [gotoCell, visCOLS, rows]);

  const openAllowancesModal = (rowIndex) => {
    const currentAllowances = rows[rowIndex]?.Allowances || [];
    setTempAllowances(currentAllowances);
    setOriginalTempAllowances(JSON.parse(JSON.stringify(currentAllowances)));
    setModalAllowanceViewIndex({});
    setModalExpandedAllowances({});
    setAllowancesModal({ open: true, rowIndex });
  };

  const closeAllowancesModal = () => {
    setAllowancesModal({ open: false, rowIndex: -1 });
    setTempAllowances([]);
    setOriginalTempAllowances([]);
    setModalAllowanceViewIndex({});
    setModalExpandedAllowances({});
  };

  const saveAllowances = () => {
    const { rowIndex } = allowancesModal;
    // tempAllowances already has all entries (original + new date entries created on date change)
    setCell(rowIndex, "Allowances", [...tempAllowances]);
    closeAllowancesModal();
  };

  const addAllowance = () => {
    setTempAllowances([...tempAllowances, { F_AllowanceMaster: "", Amount: "", Calculation: "MANUAL", IsOnGross: false, IsPFApply: false, IsESIApply: false, IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: "" }]);
  };

  const removeAllowance = (index) => {
    setTempAllowances(tempAllowances.filter((_, i) => i !== index));
  };

  const updateAllowance = (index, field, value) => {
    if (field === "EffectiveFrom") {
      setTempAllowances(prev => {
        const current = prev[index];
        // If this row is an original (from server), keep it unchanged and add a new entry
        const isOriginal = originalTempAllowances.some(
          o => String(o.F_AllowanceMaster) === String(current.F_AllowanceMaster)
            && String(o.EffectiveFrom || "").substring(0, 10) === String(current.EffectiveFrom || "").substring(0, 10)
        );
        if (isOriginal) {
          return [...prev, { ...current, EffectiveFrom: value }];
        }
        return prev.map((item, i) => i === index ? { ...item, EffectiveFrom: value } : item);
      });
    } else {
      setTempAllowances(prev => prev.map((item, i) => {
        if (i !== index) return item;
        const updated = { ...item, [field]: value };
        if (field === "Calculation" && (value === "DAILY" || value === "PERCENTAGE")) {
          updated.IsWorkingDaysApply = false;
        }
        return updated;
      }));
    }
  };

  const addAllowanceForGroup = (f_allowanceMaster) => {
    setTempAllowances(prev => [...prev, {
      F_AllowanceMaster: f_allowanceMaster, Amount: "", Calculation: "MANUAL",
      IsOnGross: false, IsPFApply: false, IsESIApply: false,
      IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: ""
    }]);
  };

  // ── Deduction Modal Helpers ───────────────────────────────────────────────
  const openDeductionsModal = (rowIndex) => {
    const currentDeductions = rows[rowIndex]?.Deductions || [];
    setTempDeductions(currentDeductions);
    setOriginalTempDeductions(JSON.parse(JSON.stringify(currentDeductions)));
    setModalDeductionViewIndex({});
    setModalExpandedDeductions({});
    setDeductionsModal({ open: true, rowIndex });
  };

  const closeDeductionsModal = () => {
    setDeductionsModal({ open: false, rowIndex: -1 });
    setTempDeductions([]);
    setOriginalTempDeductions([]);
    setModalDeductionViewIndex({});
    setModalExpandedDeductions({});
  };

  const saveDeductions = () => {
    const { rowIndex } = deductionsModal;
    // tempDeductions already has all entries (original + new date entries created on date change)
    setCell(rowIndex, "Deductions", [...tempDeductions]);
    closeDeductionsModal();
  };

  const addDeduction = () => {
    setTempDeductions([...tempDeductions, { F_DeductionMaster: "", Amount: "", Calculation: "MANUAL", IsOnGross: false, IsPFApply: false, IsESIApply: false, IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: "" }]);
  };

  const removeDeduction = (index) => {
    setTempDeductions(tempDeductions.filter((_, i) => i !== index));
  };

  const updateDeduction = (index, field, value) => {
    if (field === "EffectiveFrom") {
      setTempDeductions(prev => {
        const current = prev[index];
        // If this row is an original (from server), keep it unchanged and add a new entry
        const isOriginal = originalTempDeductions.some(
          o => String(o.F_DeductionMaster) === String(current.F_DeductionMaster)
            && String(o.EffectiveFrom || "").substring(0, 10) === String(current.EffectiveFrom || "").substring(0, 10)
        );
        if (isOriginal) {
          return [...prev, { ...current, EffectiveFrom: value }];
        }
        return prev.map((item, i) => i === index ? { ...item, EffectiveFrom: value } : item);
      });
    } else {
      setTempDeductions(prev => prev.map((item, i) => {
        if (i !== index) return item;
        const updated = { ...item, [field]: value };
        if (field === "Calculation" && (value === "DAILY" || value === "PERCENTAGE")) {
          updated.IsWorkingDaysApply = false;
        }
        return updated;
      }));
    }
  };

  const addDeductionForGroup = (f_deductionMaster) => {
    setTempDeductions(prev => [...prev, {
      F_DeductionMaster: f_deductionMaster, Amount: "", Calculation: "MANUAL",
      IsOnGross: false, IsPFApply: false, IsESIApply: false,
      IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: ""
    }]);
  };

  const delRow = (idx) => {
    setEditMode(false);
    if (rows.length === 1) { setRows([emptyRow()]); setFocus({ r: 0, c: 0 }); setAnchor({ r: 0, c: 0 }); return; }
    setRows((prev) => prev.filter((_, i) => i !== idx));
    const fix = (pos) => ({ ...pos, r: Math.max(0, pos.r >= idx ? pos.r - 1 : pos.r) });
    setFocus(fix); setAnchor(fix);
  };
  const handleSave = async () => {
    const valid = rows.filter((r) => r.Name?.trim());
    if (!valid.length) { alert("Koi bhi Employee Name nahi bhari hai."); return; }
    
    // Check for duplicate names
    const nameCount = {};
    valid.forEach((r) => { const n = r.Name.trim().toLowerCase(); nameCount[n] = (nameCount[n] || 0) + 1; });
    if (Object.values(nameCount).some((c) => c > 1)) {
      alert("Duplicate Employee Names hain! Please fix duplicate entries.");
      return;
    }

    setIsLoading(true);
    
    try {
      // Boolean COLS keys — need to convert "true"/"false" strings → actual booleans for API
      const BOOL_COLS = COLS.filter(c => c.type === "boolean").map(c => c.key);

      // Transform flat rows → API payload structure
      const payload = valid.map((row) => {
        const basic = { ...row };
        const allowancesArray = basic.Allowances || [];
        const deductionsArray = basic.Deductions || [];
        const originalData = basic._originalData || {};
        
        // Remove arrays and original data from basic object
        delete basic.Allowances;
        delete basic.Deductions;
        delete basic._originalData;

        // Convert boolean string fields back to actual booleans
        BOOL_COLS.forEach(k => { if (k in basic) basic[k] = basic[k] === "true" || basic[k] === true; });
        
        // Main Employee ID (0 for new records, keep existing for updates)
        basic.Id = basic.Id || 0;
        
        // Department History ID Logic
        const deptEffectiveDateChanged = basic.Dept_EffectiveDate !== (originalData.Dept_EffectiveDate ? String(originalData.Dept_EffectiveDate).substring(0, 10) : "");
        basic.EmployeeDepartmentLId = deptEffectiveDateChanged || !originalData.EmployeeDepartmentLId ? 0 : originalData.EmployeeDepartmentLId;
        
        // Shift History ID Logic  
        const shiftEffectiveDateChanged = basic.ShiftEffectiveFrom !== (originalData.ShiftEffectiveFrom ? String(originalData.ShiftEffectiveFrom).substring(0, 10) : "");
        basic.EmployeeShiftLId = shiftEffectiveDateChanged || !originalData.EmployeeShiftLId ? 0 : originalData.EmployeeShiftLId;
        
        // Join History ID Logic
        const joinDateChanged = basic.Join_JoinDate !== (originalData.Join_JoinDate ? String(originalData.Join_JoinDate).substring(0, 10) : "");
        const leftDateChanged = basic.Join_LeftDate !== (originalData.Join_LeftDate ? String(originalData.Join_LeftDate).substring(0, 10) : "");
        basic.EmployeeJoinDetailLId = (joinDateChanged || leftDateChanged || !originalData.EmployeeJoinDetailLId) ? 0 : originalData.EmployeeJoinDetailLId;
        
        // Salary History ID Logic
        const salaryEffectiveDateChanged = basic.Sal_EffectiveDate !== (originalData.Sal_EffectiveDate ? String(originalData.Sal_EffectiveDate).substring(0, 10) : "");
        basic.EmployeeSalaryLId = salaryEffectiveDateChanged || !originalData.EmployeeSalaryLId ? 0 : originalData.EmployeeSalaryLId;
        
        // Nominee ID Logic (keep existing if available)
        basic.EmployeeNomineeLId = originalData.EmployeeNomineeLId || 0;
        
        // Relative ID Logic (keep existing if available) 
        basic.EmployeeRelativeLId = originalData.EmployeeRelativeLId || 0;
        
        basic.AllowancesJson = JSON.stringify(allowancesArray);
        basic.DeductionsJson = JSON.stringify(deductionsArray);
        
        return basic;
      });
      
      console.log("=== Multi Employee Entry — Payload with ID Logic ===");
      console.log(JSON.stringify(payload, null, 2));
      console.table(payload.map((r) => ({ 
        Name: r.Name, 
        Id: r.Id, 
        DeptLId: r.EmployeeDepartmentLId, 
        ShiftLId: r.EmployeeShiftLId, 
        JoinLId: r.EmployeeJoinDetailLId, 
        SalaryLId: r.EmployeeSalaryLId 
      })));

      const formData = new FormData();
      formData.append("EmployeeJson", JSON.stringify(payload));
      formData.append("UserId", 0);
      
      const res = await Fn_AddEditData(
        dispatch,
        () => {}, // setState not needed here
        { arguList: { id: 0, formData } },
        'EmployeeMasterBulk/0/token',
        true,
        "memberid",
        navigate,
        "#"
      );
      
      console.log("Save response:", res);
      if (res && res?.id > 0) {
        toast.success(`${valid.length} employee(s) saved successfully!`, { autoClose: 3000 });
        // Clear the form after successful save
        setRows(Array.from({ length: 10 }, emptyRow));
        setFocus({ r: 0, c: 0 });
        setAnchor({ r: 0, c: 0 });
        setEditMode(false);
      } else {
        toast.error("Save failed. Please try again.", { autoClose: 4000 });
      }
    }
     catch (error) {
      console.error("Error saving employees:", error);
      toast.error("Error occurred while saving. Please try again.", { autoClose: 4000 });
    } finally {
      setIsLoading(false);
    }
  };

  const renderInput = (r, c) => {
    const col = visCOLS[c]; const val = rows[r]?.[col.key] ?? "";
    
    const shared = {
      ref: inputRef,
      style: { width: "100%", height: "100%", border: "none", outline: "none", background: "transparent", padding: "0 4px", fontSize: "13px", boxSizing: "border-box" },
      onKeyDown: handleKey,
      onPaste: (e) => { const text = e.clipboardData?.getData("text"); if (text && (text.includes("\t") || text.includes("\n"))) { e.preventDefault(); doPaste(text, r, c); } },
    };
    
    if (col.type === "select") {
      let options = [];
      
      // For BranchMaster, use row-specific branches
      if (col.optKey === "BranchMaster") {
        options = rowBranches[r] || [];
      } else {
        options = dropdowns[col.optKey] || [];
      }
      
      return (
        <select {...shared} value={val} onChange={(e) => { 
          // Use setCell asynchronously but don't wait for it to complete navigation
          setCell(r, col.key, e.target.value);
          c === visCOLS.length - 1 ? gotoCell(r + 1, 0) : gotoCell(r, c + 1); 
        }}>
          <option value="">{col.placeholder ?? "-- Select --"}</option>
          {options.map((o) => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
        </select>
      );
    }
    
    if (col.type === "boolean") return (
      <select {...shared} value={val} onChange={(e) => { 
        setCell(r, col.key, e.target.value); 
        c === visCOLS.length - 1 ? gotoCell(r + 1, 0) : gotoCell(r, c + 1); 
      }}>
        <option value="">-- Select --</option>
        <option value="false">No</option>
        <option value="true">Yes</option>
      </select>
    );
    return <input {...shared} type={col.type === "number" ? "number" : col.type === "time" ? "time" : col.type === "date" ? "date" : "text"} value={val} onChange={(e) => setCell(r, col.key, e.target.value)} />;
  };

  // Build group header spans
  const groupHeaderCells = (() => {
    const cells = [{ label: "", colSpan: 1, color: "#cbd5e1" }]; // S.No
    COL_GROUPS.forEach((grp) => {
      const startIdx = COLS.findIndex((c) => c.key === grp.startKey);
      const endIdx   = COLS.findIndex((c) => c.key === grp.endKey);
      if (startIdx < 0 || endIdx < 0) return;
      const visCount = COLS.slice(startIdx, endIdx + 1).filter((c) => visibleKeys.has(c.key)).length;
      if (visCount === 0) return;
      cells.push({ label: grp.label, colSpan: visCount, color: grp.color });
    });
    cells.push({ label: "", colSpan: 1, color: "#cbd5e1" }); // delete button col
    return cells;
  })();

  const filledCount = rows.filter((r) => r.Name?.trim()).length;
  const isMultiSel  = selRange.r2 > selRange.r1 || selRange.c2 > selRange.c1;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 80px)", overflow: "hidden" }}>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Multi Employee Entry" />

      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px", padding: "6px 12px", background: "#e8f5e9", borderBottom: "2px solid #217346", flexShrink: 0 }}>
        <span style={{ fontSize: "14px", fontWeight: 700, color: "#217346", marginRight: "4px" }}>
          <i className="fas fa-table me-2"></i>Multi Employee Entry
        </span>
        <button className="btn btn-sm btn-outline-info" style={{ fontSize: "12px", padding: "2px 10px" }} onClick={FetchAllEmployee} title="Reload existing employees">
          <i className="fas fa-sync me-1"></i>Refill
        </button>
        <button className="btn btn-sm btn-outline-success" style={{ fontSize: "12px", padding: "2px 10px" }} onClick={addNewRow}>
          <i className="fas fa-plus me-1"></i>Add Row
        </button>
        <button className="btn btn-sm btn-outline-danger" style={{ fontSize: "12px", padding: "2px 10px" }}
          onClick={() => { if (window.confirm("Saara data clear ho jayega. Confirm?")) { setRows(Array.from({ length: 10 }, emptyRow)); setFocus({ r: 0, c: 0 }); setAnchor({ r: 0, c: 0 }); setEditMode(false); } }}>
          <i className="fas fa-trash me-1"></i>Clear All
        </button>
        <button className="btn btn-sm btn-outline-secondary" style={{ fontSize: "12px", padding: "2px 10px" }} onClick={() => navigate("/EmployeeMaster")}>
          <i className="fas fa-arrow-left me-1"></i>Back
        </button>
        <div ref={colPickerRef} style={{ position: "relative" }}>
          <button className="btn btn-sm btn-outline-primary" style={{ fontSize: "12px", padding: "2px 10px" }} onClick={() => setColPickerOpen((p) => !p)} title="Show/Hide Columns">
            <i className="fas fa-columns me-1"></i>Columns ({visCOLS.length}/{COLS.length})
          </button>
          {colPickerOpen && (
            <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 200, background: "#fff", border: "1px solid #d0d0d0", borderRadius: "6px", boxShadow: "0 4px 18px rgba(0,0,0,0.18)", minWidth: "230px", maxHeight: "70vh", overflowY: "auto" }}>
              <div style={{ padding: "6px 12px", borderBottom: "1px solid #eee", position: "sticky", top: 0, background: "#fff", zIndex: 1, display: "flex", gap: "6px", alignItems: "center" }}>
                <span style={{ fontSize: "11px", fontWeight: 700, color: "#444", flex: 1 }}>Column Visibility</span>
                <button onClick={() => setVisibleKeys(new Set(COLS.map(c => c.key)))} style={{ fontSize: "10px", padding: "1px 8px", border: "1px solid #217346", borderRadius: "3px", background: "#e8f5e9", color: "#217346", cursor: "pointer" }}>All</button>
                <button onClick={() => setVisibleKeys(new Set())} style={{ fontSize: "10px", padding: "1px 8px", border: "1px solid #dc3545", borderRadius: "3px", background: "#fff0f0", color: "#dc3545", cursor: "pointer" }}>None</button>
              </div>
              {COL_GROUPS.map((grp) => {
                const startIdx = COLS.findIndex(c => c.key === grp.startKey);
                const endIdx   = COLS.findIndex(c => c.key === grp.endKey);
                if (startIdx < 0 || endIdx < 0) return null;
                const grpCols = COLS.slice(startIdx, endIdx + 1);
                return (
                  <div key={grp.label}>
                    <div style={{ padding: "3px 12px", background: grp.color, color: "#fff", fontSize: "11px", fontWeight: 700, letterSpacing: "0.4px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <span>{grp.label}</span>
                      <span style={{ fontSize: "10px", opacity: 0.8 }}>{grpCols.filter(c => visibleKeys.has(c.key)).length}/{grpCols.length}</span>
                    </div>
                    {grpCols.map((col) => (
                      <label key={col.key} style={{ display: "flex", alignItems: "center", gap: "7px", padding: "3px 16px", cursor: "pointer", fontSize: "12px", userSelect: "none", color: "#333" }}>
                        <input type="checkbox" checked={visibleKeys.has(col.key)} onChange={(e) => setVisibleKeys((prev) => { const next = new Set(prev); e.target.checked ? next.add(col.key) : next.delete(col.key); return next; })} />
                        {col.label}
                      </label>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <span style={{ fontSize: "11px", color: "#444", marginLeft: "4px" }}>
          <kbd style={KBD}>↑↓←→</kbd> Navigate &nbsp;
          <kbd style={KBD}>F2</kbd>/<kbd style={KBD}>DblClick</kbd> Edit &nbsp;
          <kbd style={KBD}>Type</kbd> Overwrite &nbsp;
          <kbd style={KBD}>Esc</kbd> Restore &nbsp;
          <kbd style={KBD}>Shift+Arrow</kbd> Select &nbsp;
          <kbd style={KBD}>Ctrl+C/V</kbd> Copy/Paste &nbsp;
          <kbd style={KBD}>Del</kbd> Clear
        </span>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "12px", fontWeight: 700, color: "#217346" }}>{filledCount} / {rows.length} rows filled</span>
          <button className="btn btn-sm btn-success" style={{ padding: "3px 14px", fontSize: "13px" }} onClick={handleSave} disabled={isLoading}>
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin me-1"></i>Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save me-1"></i>Save
              </>
            )}
          </button>
        </div>
      </div>

      {/* ─── Pagination Toolbar ─── */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "6px 16px",
        background: "#e8f5e9",
        borderBottom: "1px solid #ced4da",
        fontSize: "12px",
        flexShrink: 0,
        userSelect: "none"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ fontWeight: 600, color: "#217346" }}>Show:</span>
          <select
            value={pageSize}
            onChange={e => handlePageSizeChange(parseInt(e.target.value))}
            style={{ padding: "2px 6px", borderRadius: "4px", border: "1px solid #ced4da", fontSize: "12px", outline: "none", background: "#fff", cursor: "pointer" }}
          >
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </select>
          <span style={{ color: "#555" }}>
            Showing <strong>{rows.length > 0 ? startIndex + 1 : 0}</strong> - <strong>{endIndex}</strong> of <strong>{rows.length}</strong> rows
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            className="btn btn-xs btn-outline-success"
            style={{ padding: "2px 8px", fontSize: "11px", cursor: currentPage === 1 ? "default" : "pointer" }}
          >
            « First
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn btn-xs btn-outline-success"
            style={{ padding: "2px 8px", fontSize: "11px", cursor: currentPage === 1 ? "default" : "pointer" }}
          >
            ‹ Prev
          </button>
          <span style={{ padding: "0 8px", fontWeight: 700, color: "#217346" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="btn btn-xs btn-outline-success"
            style={{ padding: "2px 8px", fontSize: "11px", cursor: currentPage === totalPages ? "default" : "pointer" }}
          >
            Next ›
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="btn btn-xs btn-outline-success"
            style={{ padding: "2px 8px", fontSize: "11px", cursor: currentPage === totalPages ? "default" : "pointer" }}
          >
            Last »
          </button>
        </div>
      </div>

      <div ref={gridRef} tabIndex={0} onKeyDown={handleGridKeyDown} style={{ flex: 1, overflowX: "auto", overflowY: "auto", outline: "none", background: "#fff" }}>
        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", fontSize: "13px", userSelect: "none" }}>
          <thead>
            {/* Group header row */}
            <tr>
              {groupHeaderCells.map((g, i) => (
                <th key={i} colSpan={g.colSpan} style={{ background: g.color || "#cbd5e1", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", textAlign: "center", fontSize: "11px", fontWeight: 700, height: "22px", position: "sticky", top: 0, zIndex: 6, boxSizing: "border-box", letterSpacing: "0.5px" }}>
                  {g.label}
                </th>
              ))}
            </tr>
            {/* Column header row */}
            <tr>
              <th style={{ ...TH_NUM, top: "22px" }}></th>
              {visCOLS.map((col, ci) => (
                <th key={ci} style={{ ...thCol(col.w, ci >= selRange.c1 && ci <= selRange.c2), top: "22px", minWidth: `${col.w}px`, width: `${col.w}px` }}>
                  <span style={{ marginRight: "4px", opacity: 0.6, fontWeight: 400, fontSize: "10px" }}>{colLetter(ci)}</span>
                  {col.label}
                </th>
              ))}
              <th style={{ ...TH_NUM, top: "22px", width: "36px", minWidth: "36px" }}></th>
            </tr>
          </thead>
          <tbody>
            {rows.slice(startIndex, endIndex).map((row, localRi) => {
              const ri = startIndex + localRi;
              return (
                <tr key={ri}>
                  <td style={rnTd(ri, focus.r)}>{ri + 1}</td>
                  {visCOLS.map((col, ci) => {
                    const focused = isFoc(ri, ci); const selected = inSel(ri, ci);
                    return (
                      <td key={ci} ref={focused ? focusedCellRef : null}
                        style={{ ...tdStyle(focused, selected, ri, focused && editMode), minWidth: `${col.w}px`, width: `${col.w}px` }}
                        onMouseDown={(e) => handleCellClick(ri, ci, e)}
                        onDoubleClick={() => enterEditMode(ri, ci, null)}
                      >
                        {focused && editMode ? renderInput(ri, ci) : (() => {
                          // Special handling for BranchMaster display to show correct branch name
                          let dv;
                          if (col.type === "select" && col.optKey === "BranchMaster") {
                            const branches = rowBranches[ri] || [];
                            const opt = branches.find((o) => String(o.Id) === String(row[col.key]));
                            dv = opt ? opt.Name : "";
                          } else {
                            dv = displayVal(col, row[col.key]);
                          }
                          
                          const isEmptySel = !dv && (col.type === "select" || col.type === "boolean");
                          const isClickableModal = col.type === "modal";
                          return (
                            <span style={{ 
                              display: "block", 
                              padding: "0 4px", 
                              overflow: "hidden", 
                              textOverflow: "ellipsis", 
                              whiteSpace: "nowrap", 
                              lineHeight: "26px", 
                              color: isEmptySel ? "#b0b7c3" : isClickableModal ? "#1565c0" : row[col.key] ? "#212529" : "#ccc", 
                              fontWeight: focused ? 600 : 400, 
                              fontStyle: isEmptySel ? "italic" : "normal",
                              cursor: isClickableModal ? "pointer" : "cell",
                              textDecoration: isClickableModal ? "underline" : "none"
                            }}
                            onClick={isClickableModal ? () => {
                              if (col.key === "Allowances") openAllowancesModal(ri);
                              else if (col.key === "Deductions") openDeductionsModal(ri);
                            } : undefined}
                            >
                              {isEmptySel ? (col.placeholder?.replace(/^-- | --$/g, "") ?? "Select...") : (dv || "\u00A0")}
                            </span>
                          );
                        })()}
                      </td>
                    );
                  })}
                  <td style={{ width: "36px", minWidth: "36px", height: "28px", border: "1px solid #d0d0d0", textAlign: "center", background: "#fafafa", padding: 0 }}>
                    <button onClick={() => delRow(ri)} title="Row delete" style={{ border: "none", background: "none", color: "#dc3545", fontSize: "18px", lineHeight: 1, cursor: "pointer", width: "100%", height: "100%", fontWeight: 700 }}>×</button>
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan={visCOLS.length + 2} onClick={addNewRow}
                style={{ border: "1px dashed #b0b0b0", textAlign: "center", color: "#aaa", fontSize: "12px", cursor: "pointer", height: "28px", background: "#fafafa", userSelect: "none" }}>
                ＋ Click here to add a new row
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ flexShrink: 0, padding: "3px 12px", background: "#e8f5e9", borderTop: "1px solid #a5d6a7", fontSize: "12px", color: "#555", display: "flex", gap: "24px", alignItems: "center" }}>
        <span>Cell: <strong style={{ color: "#217346" }}>{colLetter(focus.c)}{focus.r + 1}</strong></span>
        {isMultiSel && (
          <span>Selection: <strong>{colLetter(selRange.c1)}{selRange.r1 + 1} → {colLetter(selRange.c2)}{selRange.r2 + 1}</strong> ({selRange.r2 - selRange.r1 + 1}R × {selRange.c2 - selRange.c1 + 1}C)</span>
        )}
        <span style={{ marginLeft: "auto", color: "#666" }}>
          <i className="fas fa-info-circle me-1" style={{ color: "#217346" }}></i>
          Excel se copy karke Ctrl+V se directly paste karo — multi-cell auto-fill hoga
        </span>
      </div>

      {/* Allowances Modal */}
      {allowancesModal.open && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)", width: "90%", maxWidth: "600px", maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
            {/* Modal Header */}
            <div style={{ padding: "16px 20px", borderBottom: "1px solid #e0e0e0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h5 style={{ margin: 0, color: "#217346", fontWeight: 700 }}>
                <i className="fas fa-coins me-2"></i>
                Manage Allowances - Row {allowancesModal.rowIndex + 1}
              </h5>
              <button onClick={closeAllowancesModal} style={{ background: "none", border: "none", fontSize: "20px", color: "#666", cursor: "pointer", padding: "0", width: "24px", height: "24px" }}>
                ×
              </button>
            </div>
            
            {/* Modal Body */}
            <div style={{ padding: "16px 20px", flex: 1, overflowY: "auto", minHeight: "200px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Allowances List</span>
                <button className="btn btn-sm btn-success" onClick={addAllowance} style={{ fontSize: "12px", padding: "4px 12px" }}>
                  <i className="fas fa-plus me-1"></i>Add Allowance
                </button>
              </div>
              
              {tempAllowances.length === 0 ? (
                <div style={{ textAlign: "center", color: "#999", fontStyle: "italic", padding: "40px 0" }}>
                  No allowances added yet. Click "Add Allowance" to start.
                </div>
              ) : (() => {
                // Group by F_AllowanceMaster
                const groups = {};
                tempAllowances.forEach((row, i) => {
                  const key = row.F_AllowanceMaster || `new_${i}`;
                  if (!groups[key]) groups[key] = [];
                  groups[key].push({ row, index: i });
                });
                Object.values(groups).forEach(g => g.sort((a, b) => (a.row.EffectiveFrom || "").localeCompare(b.row.EffectiveFrom || "")));

                return Object.entries(groups).map(([key, entries]) => {
                  const total = entries.length;
                  const viewIdx = modalAllowanceViewIndex[key] ?? (total - 1);
                  const { row: allowance, index } = entries[viewIdx] || entries[total - 1];
                  const allowanceName = (dropdowns.AllowanceMaster || []).find(a => String(a.Id) === String(allowance.F_AllowanceMaster))?.Name || "Allowance";
                  const isExpanded = !!modalExpandedAllowances[key];

                  return (
                    <div key={key} style={{ border: "1px solid #e0e0e0", borderRadius: "6px", marginBottom: "10px", background: "#fff" }}>
                      {/* Card Header */}
                      <div style={{ padding: "8px 12px", background: "#f8f9fa", borderBottom: isExpanded ? "1px solid #e0e0e0" : "none", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: isExpanded ? "6px 6px 0 0" : "6px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                          <button type="button" onClick={() => setModalExpandedAllowances(prev => ({ ...prev, [key]: !prev[key] }))}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "11px", padding: "0 2px" }}>
                            {isExpanded ? "▼" : "▶"}
                          </button>
                          <strong style={{ fontSize: "13px", color: "#333" }}>{allowanceName}</strong>
                          {!isExpanded && (
                            <small style={{ color: "#888", marginLeft: "6px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              Rate: {allowance.Amount || "-"} | {allowance.Calculation || "-"} | {allowance.EffectiveFrom ? allowance.EffectiveFrom.split("T")[0] : "-"}
                              {allowance.IsPFApply ? " | PF" : ""}{allowance.IsESIApply ? " | ESI" : ""}{allowance.IsApplicable ? " | Active" : ""}
                            </small>
                          )}
                          {total > 1 && (
                            <span style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "8px" }}>
                              <button type="button" disabled={viewIdx === 0} onClick={() => setModalAllowanceViewIndex(prev => ({ ...prev, [key]: viewIdx - 1 }))}
                                style={{ background: "none", border: "1px solid #ccc", borderRadius: "3px", padding: "0 5px", cursor: viewIdx === 0 ? "default" : "pointer", opacity: viewIdx === 0 ? 0.4 : 1, fontSize: "11px" }}>◀</button>
                              <small style={{ color: "#666" }}>{viewIdx + 1}/{total}</small>
                              <button type="button" disabled={viewIdx === total - 1} onClick={() => setModalAllowanceViewIndex(prev => ({ ...prev, [key]: viewIdx + 1 }))}
                                style={{ background: "none", border: "1px solid #ccc", borderRadius: "3px", padding: "0 5px", cursor: viewIdx === total - 1 ? "default" : "pointer", opacity: viewIdx === total - 1 ? 0.4 : 1, fontSize: "11px" }}>▶</button>
                            </span>
                          )}
                        </div>
                        <button onClick={() => removeAllowance(index)} title="Remove this entry" style={{ background: "none", border: "none", color: "#dc3545", fontWeight: "bold", fontSize: "15px", cursor: "pointer", lineHeight: 1 }}>
                          ✕
                        </button>
                      </div>
                      {/* Card Body */}
                      {isExpanded && (
                      <div style={{ padding: "10px 12px", fontSize: "13px" }}>
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>NAME</label>
                            <select className="form-control form-control-sm" value={allowance.F_AllowanceMaster || ""} onChange={(e) => updateAllowance(index, "F_AllowanceMaster", e.target.value)}>
                              <option value="">-- Select --</option>
                              {(dropdowns.AllowanceMaster || []).map((a) => <option key={a.Id} value={a.Id}>{a.Name}</option>)}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-3">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>DATE</label>
                            <input type="date" className="form-control form-control-sm" value={allowance.EffectiveFrom ? allowance.EffectiveFrom.split("T")[0] : ""} onChange={(e) => updateAllowance(index, "EffectiveFrom", e.target.value)} />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>RATE</label>
                            <input type="number" step="0.01" className="form-control form-control-sm" value={allowance.Amount || ""} onChange={(e) => updateAllowance(index, "Amount", e.target.value)} />
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>CALCULATION</label>
                            <div className="d-flex gap-3 mt-1">
                              {["MANUAL", "PERCENTAGE", "DAILY"].map((opt) => (
                                <div key={opt} className="form-check">
                                  <input className="form-check-input" type="radio" name={`mcalc_${index}`} id={`mcalc_${index}_${opt}`} value={opt} checked={allowance.Calculation === opt} onChange={(e) => updateAllowance(index, "Calculation", e.target.value)} />
                                  <label className="form-check-label" htmlFor={`mcalc_${index}_${opt}`} style={{ fontSize: "12px" }}>{opt}</label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_onGross_${index}`} checked={!!allowance.IsOnGross} onChange={(e) => updateAllowance(index, "IsOnGross", e.target.checked)} /><label className="form-check-label" htmlFor={`m_onGross_${index}`} style={{ fontSize: "12px" }}>ON GROSS</label></div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_pfApply_${index}`} checked={!!allowance.IsPFApply} onChange={(e) => updateAllowance(index, "IsPFApply", e.target.checked)} /><label className="form-check-label" htmlFor={`m_pfApply_${index}`} style={{ fontSize: "12px" }}>PF APPLY</label></div>
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_esiApply_${index}`} checked={!!allowance.IsESIApply} onChange={(e) => updateAllowance(index, "IsESIApply", e.target.checked)} /><label className="form-check-label" htmlFor={`m_esiApply_${index}`} style={{ fontSize: "12px" }}>ESI APPLY</label></div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_roundOff_${index}`} checked={!!allowance.IsRoundOffApply} onChange={(e) => updateAllowance(index, "IsRoundOffApply", e.target.checked)} /><label className="form-check-label" htmlFor={`m_roundOff_${index}`} style={{ fontSize: "12px" }}>ROUNDED OFF</label></div>
                          </div>
                        </div>
                        <div className="row">
                          {allowance.Calculation === "MANUAL" && (
                            <div className="col-md-4">
                              <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_workDays_${index}`} checked={!!allowance.IsWorkingDaysApply} onChange={(e) => updateAllowance(index, "IsWorkingDaysApply", e.target.checked)} /><label className="form-check-label" htmlFor={`m_workDays_${index}`} style={{ fontSize: "12px" }}>WORKING DAYS APPLY</label></div>
                            </div>
                          )}
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`m_applicable_${index}`} checked={!!allowance.IsApplicable} onChange={(e) => updateAllowance(index, "IsApplicable", e.target.checked)} /><label className="form-check-label" htmlFor={`m_applicable_${index}`} style={{ fontSize: "12px" }}>APPLICABLE</label></div>
                          </div>
                        </div>
                      </div>
                      )}
                    </div>
                  );
                });
              })()}
            </div>
            
            {/* Modal Footer */}
            <div style={{ padding: "12px 20px", borderTop: "1px solid #e0e0e0", display: "flex", justifyContent: "flex-end", gap: "8px" }}>
              <button className="btn btn-sm btn-secondary" onClick={closeAllowancesModal} style={{ fontSize: "12px", padding: "6px 16px" }}>
                <i className="fas fa-times me-1"></i>Cancel
              </button>
              <button className="btn btn-sm btn-success" onClick={saveAllowances} style={{ fontSize: "12px", padding: "6px 16px" }}>
                <i className="fas fa-check me-1"></i>Save Allowances
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Deductions Modal */}
      {deductionsModal.open && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)", width: "90%", maxWidth: "600px", maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
            {/* Modal Header */}
            <div style={{ padding: "16px 20px", borderBottom: "1px solid #e0e0e0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h5 style={{ margin: 0, color: "#ad1457", fontWeight: 700 }}>
                <i className="fas fa-minus-circle me-2"></i>
                Manage Deductions - Row {deductionsModal.rowIndex + 1}
              </h5>
              <button onClick={closeDeductionsModal} style={{ background: "none", border: "none", fontSize: "20px", color: "#666", cursor: "pointer", padding: "0", width: "24px", height: "24px" }}>×</button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "16px 20px", flex: 1, overflowY: "auto", minHeight: "200px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Deductions List</span>
                <button className="btn btn-sm btn-danger" onClick={addDeduction} style={{ fontSize: "12px", padding: "4px 12px" }}>
                  <i className="fas fa-plus me-1"></i>Add Deduction
                </button>
              </div>

              {tempDeductions.length === 0 ? (
                <div style={{ textAlign: "center", color: "#999", fontStyle: "italic", padding: "40px 0" }}>
                  No deductions added yet. Click "Add Deduction" to start.
                </div>
              ) : (() => {
                const groups = {};
                tempDeductions.forEach((row, i) => {
                  const key = row.F_DeductionMaster || `new_${i}`;
                  if (!groups[key]) groups[key] = [];
                  groups[key].push({ row, index: i });
                });
                Object.values(groups).forEach(g => g.sort((a, b) => (a.row.EffectiveFrom || "").localeCompare(b.row.EffectiveFrom || "")));

                return Object.entries(groups).map(([key, entries]) => {
                  const total = entries.length;
                  const viewIdx = modalDeductionViewIndex[key] ?? (total - 1);
                  const { row: ded, index } = entries[viewIdx] || entries[total - 1];
                  const dedName = (dropdowns.DeductionMaster || []).find(d => String(d.Id) === String(ded.F_DeductionMaster))?.Name || "Deduction";
                  const isExpanded = !!modalExpandedDeductions[key];

                  return (
                    <div key={key} style={{ border: "1px solid #e0e0e0", borderRadius: "6px", marginBottom: "10px", background: "#fff" }}>
                      {/* Card Header */}
                      <div style={{ padding: "8px 12px", background: "#fdf0f4", borderBottom: isExpanded ? "1px solid #e0e0e0" : "none", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: isExpanded ? "6px 6px 0 0" : "6px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                          <button type="button" onClick={() => setModalExpandedDeductions(prev => ({ ...prev, [key]: !prev[key] }))}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "11px", padding: "0 2px" }}>
                            {isExpanded ? "▼" : "▶"}
                          </button>
                          <strong style={{ fontSize: "13px", color: "#ad1457" }}>{dedName}</strong>
                          {!isExpanded && (
                            <small style={{ color: "#888", marginLeft: "6px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              Rate: {ded.Amount || "-"} | {ded.Calculation || "-"} | {ded.EffectiveFrom ? ded.EffectiveFrom.split("T")[0] : "-"}
                              {ded.IsPFApply ? " | PF" : ""}{ded.IsESIApply ? " | ESI" : ""}{ded.IsApplicable ? " | Active" : ""}
                            </small>
                          )}
                          {total > 1 && (
                            <span style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "8px" }}>
                              <button type="button" disabled={viewIdx === 0} onClick={() => setModalDeductionViewIndex(prev => ({ ...prev, [key]: viewIdx - 1 }))}
                                style={{ background: "none", border: "1px solid #ccc", borderRadius: "3px", padding: "0 5px", cursor: viewIdx === 0 ? "default" : "pointer", opacity: viewIdx === 0 ? 0.4 : 1, fontSize: "11px" }}>◀</button>
                              <small style={{ color: "#666" }}>{viewIdx + 1}/{total}</small>
                              <button type="button" disabled={viewIdx === total - 1} onClick={() => setModalDeductionViewIndex(prev => ({ ...prev, [key]: viewIdx + 1 }))}
                                style={{ background: "none", border: "1px solid #ccc", borderRadius: "3px", padding: "0 5px", cursor: viewIdx === total - 1 ? "default" : "pointer", opacity: viewIdx === total - 1 ? 0.4 : 1, fontSize: "11px" }}>▶</button>
                            </span>
                          )}
                        </div>
                        <button onClick={() => removeDeduction(index)} title="Remove this entry" style={{ background: "none", border: "none", color: "#dc3545", fontWeight: "bold", fontSize: "15px", cursor: "pointer", lineHeight: 1 }}>
                          ✕
                        </button>
                      </div>
                      {/* Card Body */}
                      {isExpanded && (
                      <div style={{ padding: "10px 12px", fontSize: "13px" }}>
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>NAME</label>
                            <select className="form-control form-control-sm" value={ded.F_DeductionMaster || ""} onChange={(e) => updateDeduction(index, "F_DeductionMaster", e.target.value)}>
                              <option value="">-- Select --</option>
                              {(dropdowns.DeductionMaster || []).map((d) => <option key={d.Id} value={d.Id}>{d.Name}</option>)}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-3">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>DATE</label>
                            <input type="date" className="form-control form-control-sm" value={ded.EffectiveFrom ? ded.EffectiveFrom.split("T")[0] : ""} onChange={(e) => updateDeduction(index, "EffectiveFrom", e.target.value)} />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>RATE</label>
                            <input type="number" step="0.01" className="form-control form-control-sm" value={ded.Amount || ""} onChange={(e) => updateDeduction(index, "Amount", e.target.value)} />
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label className="form-label mb-0" style={{ fontSize: "11px", fontWeight: 600, color: "#555" }}>CALCULATION</label>
                            <div className="d-flex gap-3 mt-1">
                              {["MANUAL", "PERCENTAGE", "DAILY"].map((opt) => (
                                <div key={opt} className="form-check">
                                  <input className="form-check-input" type="radio" name={`ddcalc_${index}`} id={`ddcalc_${index}_${opt}`} value={opt} checked={ded.Calculation === opt}
                                    onChange={(e) => updateDeduction(index, "Calculation", e.target.value)} />
                                  <label className="form-check-label" htmlFor={`ddcalc_${index}_${opt}`} style={{ fontSize: "12px" }}>{opt}</label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_onGross_${index}`} checked={!!ded.IsOnGross} onChange={(e) => updateDeduction(index, "IsOnGross", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_onGross_${index}`} style={{ fontSize: "12px" }}>ON GROSS</label></div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_pfApply_${index}`} checked={!!ded.IsPFApply} onChange={(e) => updateDeduction(index, "IsPFApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_pfApply_${index}`} style={{ fontSize: "12px" }}>PF APPLY</label></div>
                          </div>
                        </div>
                        <div className="row mb-1">
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_esiApply_${index}`} checked={!!ded.IsESIApply} onChange={(e) => updateDeduction(index, "IsESIApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_esiApply_${index}`} style={{ fontSize: "12px" }}>ESI APPLY</label></div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_roundOff_${index}`} checked={!!ded.IsRoundOffApply} onChange={(e) => updateDeduction(index, "IsRoundOffApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_roundOff_${index}`} style={{ fontSize: "12px" }}>ROUNDED OFF</label></div>
                          </div>
                        </div>
                        <div className="row">
                          {ded.Calculation === "MANUAL" && (
                            <div className="col-md-4">
                              <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_workDays_${index}`} checked={!!ded.IsWorkingDaysApply} onChange={(e) => updateDeduction(index, "IsWorkingDaysApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_workDays_${index}`} style={{ fontSize: "12px" }}>WORKING DAYS APPLY</label></div>
                            </div>
                          )}
                          <div className="col-md-3">
                            <div className="form-check"><input className="form-check-input" type="checkbox" id={`dd_applicable_${index}`} checked={!!ded.IsApplicable} onChange={(e) => updateDeduction(index, "IsApplicable", e.target.checked)} /><label className="form-check-label" htmlFor={`dd_applicable_${index}`} style={{ fontSize: "12px" }}>APPLICABLE</label></div>
                          </div>
                        </div>
                      </div>
                      )}
                    </div>
                  );
                });
              })()}
            </div>

            {/* Modal Footer */}
            <div style={{ padding: "12px 20px", borderTop: "1px solid #e0e0e0", display: "flex", justifyContent: "flex-end", gap: "8px" }}>
              <button className="btn btn-sm btn-secondary" onClick={closeDeductionsModal} style={{ fontSize: "12px", padding: "6px 16px" }}>
                <i className="fas fa-times me-1"></i>Cancel
              </button>
              <button className="btn btn-sm btn-danger" onClick={saveDeductions} style={{ fontSize: "12px", padding: "6px 16px" }}>
                <i className="fas fa-check me-1"></i>Save Deductions
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default MultiEmployeeEntry;
